import React from 'react'

const Thankyou = () => (
  <div className="page-content">
    <div className="row">
      <div className="col-md-12">
        <h4 className="text-center">Thankyou</h4>
      </div>
    </div>
  </div>
)

export default Thankyou
